import script from "./VideoDetailPageNavMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoDetailPageNavMenu.vue?vue&type=script&setup=true&lang=js"

import "./VideoDetailPageNavMenu.vue?vue&type=style&index=0&id=67e36f7e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e36f7e"]])

export default __exports__